import React from "react";
import { createContext, useReducer, useContext } from "react";
import { v4 as uuidv4 } from "uuid";

import * as ACTION from "./action";

const TemplatesContext = createContext();

const templatesReducer = (state, action) => {
  switch (action.type) {
    case ACTION.UPDATE_SEARCH_CRITERIA: {
      return {
        ...state,
        search: {
          ...state.search,
          uuid: uuidv4(),
          deleted: action.deleted,
          draft: action.draft,
          name: action.name,
          offset: action.offset,
          limit: action.limit,
        },
        results: {
          ...state.results,
          templates: null,
        },
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

export const TemplatesProvider = ({ children }) => {
  const [state, dispatch] = useReducer(templatesReducer, {
    search: {
      uuid: uuidv4(),
      deleted: false,
      draft: false,
      name: null,
      offset: 0,
      limit: 10,
    },
  });
  const value = { state, dispatch };

  return (
    <TemplatesContext.Provider value={value}>
      {children}
    </TemplatesContext.Provider>
  );
};

export const useTemplates = () => {
  const context = useContext(TemplatesContext);
  if (context === undefined) {
    throw new Error("useTemplates must be used within a TemplatesProvider");
  }
  return context;
};
